import React, { Fragment } from 'react'
import { Route } from 'react-router'
import { LiveLogsContainer, LiveLogDemo } from '../LiveLogPage'

export const routes = (
  <Fragment>
    <Route path='/users/:userId/live_log' component={LiveLogsContainer} />
    <Route path='/live_log_demo' component={LiveLogDemo} />
  </Fragment>
)
